import React, { useState, useEffect } from "react";
import styles from "./Prompts.module.css";
import Button from "../buttons/Button";
import FullscreenCard from "../containers/FullscreenCard";

const StatusPrompt = ({ text, isActive, statusCleared }) => {
  const [divClass, setDivClass] = useState(styles.statusDivInactive);

  useEffect(() => {
    setDivClass(isActive ? styles.statusDivActive : styles.statusDivInactive);
  }, [isActive]);

  const onClickHandler = (event) => {
    event.preventDefault();
    setDivClass(styles.statusDivInactive);
    statusCleared();
  };

  return (
    <FullscreenCard>
      <div className={divClass}>
        <p>{text}</p>
        <Button text={"OK"} disabled={false} onClick={onClickHandler} />
      </div>
    </FullscreenCard>
  );
};

export default StatusPrompt;
